module.exports = __webpack_public_path__ + "media/shagbark_the_plush.4b20eed1.webm";